import { Nullable } from '@shared/models/types/primary'

import { ChatWidget } from '@protos/apps/pc/chat_widget_pb'

import Bubble from '@pc/assets/images/bubbles.png'
import agentIcon from '@pc/assets/images/logo-no-bg.svg?inline'
import Square from '@pc/assets/images/square.png'

export const CUSTOM_ICON = 'custom'

export const enum ValueNames {
  Bubbles = '/bubbles',
  Square = '/square',
}

export const defaultIcon = {
  [ValueNames.Bubbles]: Bubble,
  [ValueNames.Square]: Square,
}

export const getLauncherIcon = (widget?: Nullable<ChatWidget>) => {
  const { launcherIcon, iconUrl } = widget?.branding ?? {}

  if (launcherIcon === CUSTOM_ICON && iconUrl) {
    return iconUrl
  }

  return (launcherIcon && defaultIcon[launcherIcon as ValueNames]) || agentIcon
}
